module.exports = __webpack_public_path__ + "static/media/carousalRightArrow.bc39653a.svg";